const DocumentsAssignSignatureIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.44874 17.2792V21.7276C9.44874 22.358 10.061 22.8069 10.6622 22.6173L18.9025 20.0184C19.2907 19.896 19.5547 19.5359 19.5547 19.1288V4.65328C19.5547 4.23888 19.2814 3.87415 18.8836 3.75789L10.6433 1.34919C10.0462 1.17464 9.44874 1.62244 9.44874 2.24458V6.37809L4.65838 7.03132C4.19616 7.09435 3.85156 7.48913 3.85156 7.95563V15.7288C3.85156 16.1973 4.19902 16.5931 4.66354 16.6538L9.44874 17.2792ZM9.44874 17.2792L16.4798 18.198C17.0383 18.271 17.5335 17.8362 17.5335 17.273V6.34432C17.5335 5.77902 17.0348 5.34363 16.4746 5.42001L9.44874 6.37809V17.2792Z"
        fill="#298EE6"
      />
    </svg>
  );
};
export default DocumentsAssignSignatureIcon;
